import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from "@angular/router";
import { AddNewTopicsComponent } from '../add-new-topics/add-new-topics.component';
import { FormService } from '../form/form.service';
import { SharedService } from '../services/shared.service';
import { SortTopicsService } from '../sort-topics/sort-topics.service';
import { CloneTemplateComponent } from '../sortforms/clone-template/clone-template.component';
import { SortformsService } from '../sortforms/sortforms.service';

@Component({
  selector: 'app-create-form',
  templateUrl: './create-form.component.html',
  styleUrls: ['./create-form.component.scss']
})
export class CreateFormComponent implements OnInit {

  templates: any = [];
  newForm: boolean = true;
  newTitle: boolean = false;
  topicSettings: boolean = false;
  topics: boolean = false;
  formTitle: string = "";
  topicsList = [];
  settingsTitle: string = "";
  topicIndex;
  elements = [];
	bgTextColor = "#000000";
  organizationId = localStorage.getItem("organization");

  constructor(
    private _router: Router,
    private _sortFormService: SortformsService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _formService: FormService,
    private _sortTopicsService: SortTopicsService,
    private _sharedService: SharedService,
    private cd: ChangeDetectorRef,
    private _activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    if(this._activatedRoute.snapshot.queryParams['organization']) {
      this.organizationId = this._activatedRoute.snapshot.queryParams['organization'];
    }
    this.onInit();
  }


  check(hex) {
		if (/[0-9A-F]{6}$/i.test(hex)) {
			return true;
		}
	}

  ngAfterViewChecked() {
		if (this.check(this.bgTextColor)) {
			this._sharedService.updateHomeColor(this.bgTextColor);
		}
	}
  
  onInit(): void {
		if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
    // Get old templates to clone
    this._sortFormService.getAllTemplates(this.organizationId).subscribe((response) => {
      if (response['success']) {
        this.templates = response['data'];
      }
    }, (error) => {
      console.error(error);
    });
  }

  createNewForm(): void {
    // this._sharedService.confirmationDialog(
    //   "You would like to build a new form from scratch?",
    //   () => {
        const dialogRef = this.dialog.open(CloneTemplateComponent, {
          data: {
            "copyOf": "",
            "newForm": true
          }
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result && result["rename"]) {
            // Creating request object
            let requestData = {
              name: result["value"],
              code: this.generateRandomCode(),
              organization: this.organizationId,
              updated_at: Date.now(),
              is_archived: false,
              is_embeddable: false,
              auth_required: false,
              embed_link: "",
              hashed_password: "",
              salt: "",
              template_schema: this.getBasicTemplateSchema(result["value"])
            };
    
            // API call
            this._formService.saveTemplate(requestData).subscribe((response) => {
              if (response['success']) {
                this._router.navigate(["form-builder"], { queryParams: { id: response["id"], isNewForm: true } });
              } else {
                this.openSnackBar(response["message"]);
              }
            });
          }
        });
    //   }
    // );
  }

  getBasicTemplateSchema(name) {
    let template_schema = {
      schema: [
        {
          "label": "Describe your form here",
          "placeholder": "Describe your form here",
          "key": "readtext",
          "type": "readtext",
          "validate": {
            "minlength": 4,
            "maxlength": 8
          },
          "visible": true
        },
        {
          "label": "Topics",
          "placeholder": "",
          "key": "topic",
          "type": "select",
          "validate": {
              "required": true
          },
          "data": [],
          "dependent_key": "subtopic"
        },
        {
          "label": "Additional Information",
          "placeholder": "",
          "key": "subtopic",
          "type": "select",
          "validate": {
              "required": true
          },
          "data": [],
          "dependent_data": {}
        },
        {
          "label": "Name",
          "placeholder": "Please enter your name",
          "key": "employeename",
          "type": "text",
          "validate": {
              "required": true,
              "minlength": 4,
              "maxlength": 8
          }
        },
        {
          "label": "Comments",
          "placeholder": "",
          "key": "subject",
          "type": "textarea",
          "validate": {
              "required": true,
              "minlength": 1,
              "maxlength": 300
          }
        },
        {
          "label": "Admin Notes",
          "placeholder": "",
          "key": "admin_notes",
          "type": "admin_notes"
        }
      ]
    };

    return template_schema;
  }

  cloneTemplate(template) {
    const dialogRef = this.dialog.open(CloneTemplateComponent, {
      data: {
        "copyOf": template.name,
        "newForm": false
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result["rename"]) {
        let admin_notes = {
          "label": "Admin Notes",
          "placeholder": "",
          "key": "admin_notes",
          "type": "admin_notes"
        }
        template.template_schema.schema.push(admin_notes);

        // Creating request object
        let requestData = {
          name: result["value"],
          code: this.generateRandomCode(),
          organization: localStorage.getItem('organization'),
          updated_at: Date.now(),
          is_archived: false,
          is_embeddable: false,
          auth_required: false,
          embed_link: "",
          hashed_password: "",
          salt: "",
          template_schema: template.template_schema,
          templateId: template._id
        };

        // API call
        this._formService.saveTemplate(requestData).subscribe((response) => {
          if (response['success']) {
            this._router.navigate(["form-builder"], { queryParams: { id: response["id"] } });
          } else {
            this.openSnackBar(response["message"]);
          }
        });
      }
    });
  }

  generateRandomCode() {
    let randomString = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let charactersLength = characters.length;
    for ( let i = 0; i < 11; i++ ) {
      randomString += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return randomString;
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000
    });
  }

  onReloadClick(): void {
		this.onInit();
	}

  titleChange(value): void {
    this.formTitle = value;
  }

  showTopicsPanel(): void {
    if (this.formTitle.length > 0) {
      this.newForm = false;
      this.newTitle = false;
      this.topics = true;
      this.topicSettings = false;
    }
  }


  openSubtopicSettings(topic, i, header): void {
    this.elements = [];
    this.elements = topic["sub_topics"];
    this.topicIndex = i;
    this.settingsTitle = header;
    this.newForm = false;
    this.newTitle = false;
    this.topics = false;
    this.topicSettings = true;
  }

  openSmsSettings(topic, i, header): void {
    this.elements = [];
    this.elements = topic["sms"];
    this.topicIndex = i;
    this.settingsTitle = header;
    this.newForm = false;
    this.newTitle = false;
    this.topics = false;
    this.topicSettings = true;
  }

  openEmailSettings(topic, i, header): void {
    this.elements = [];
    this.elements = topic["emails"];
    this.topicIndex = i;
    this.settingsTitle = header;
    this.newForm = false;
    this.newTitle = false;
    this.topics = false;
    this.topicSettings = true;
  }

  updateTopic() {

		let topic = {
			_id: this.topicsList[this.topicIndex]['_id'],
			name: this.topicsList[this.topicIndex].name,
			sub_topics: this.topicsList[this.topicIndex].sub_topics.length > 0 ? this.topicsList[this.topicIndex].sub_topics.filter(function (e) { return e }) : [],
			emails: this.topicsList[this.topicIndex].emails.length > 0 ? this.topicsList[this.topicIndex].emails.filter(function (e) { return e }) : [],
			sms: this.topicsList[this.topicIndex].sms.length > 0 ? this.topicsList[this.topicIndex].sms.filter(function (e) { return e }) : []
		}
		this._sortTopicsService.updateTopic(topic).subscribe((response) => {
			if (response['success']) {
				// this.dialogRef.close();
			}
		});
	}

  openAddNewItem() {
    this.elements.push("");
  }

  addNewTopic() {
    const dialogRef = this.dialog.open(AddNewTopicsComponent, {
      data: {}
    });
    dialogRef.afterClosed().subscribe((data) => {
      document.body.classList.remove('modal-open');
      this.onInit();
    })
  }

  backToShowTopicsPanel() {
    this.newForm = false;
    this.newTitle = false;
    this.topicSettings = false;
    this.topics = true;
    this.onInit();
  }

  fieldPropertiesInputChange(value, index) {
    if (this.settingsTitle === "Sub Topics") {
      this.topicsList[this.topicIndex]["sub_topics"][index] = value;
    } else if (this.settingsTitle === "cc-SMS") {
      this.topicsList[this.topicIndex]["sms"][index] = value;
    } else {
      this.topicsList[this.topicIndex]["emails"][index] = value;
    }
  }

  removeOption(element, index) {
    this.elements.splice(index, 1);
  }

  onSliderChange(event, index) {
    if (this.topicsList[index]["checked"]) {
      this.topicsList[index]["checked"] = false;
      this.cd.detectChanges();
    } else {
      this.topicsList[index]["checked"] = true;
      this.cd.detectChanges();
    }
  }

  openFormBuilder(): void {
    let data = [this.topicsList, this.formTitle];
    this._sharedService.passData(data);
    this._router.navigate(["/form-builder"]);
  }

  goToTitlePanel() {
    this.createNewForm();
  }
}
